var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8942 6.33676V11.2539C10.8942 11.3522 10.8352 11.4456 10.7418 11.48C10.7123 11.4948 10.6779 11.4997 10.6484 11.4997C10.5845 11.4997 10.5205 11.4752 10.4714 11.426L9.58137 10.5163H5.23958C4.29058 10.5163 3.5186 9.7443 3.5186 8.7953H7.20642C8.56354 8.7953 9.66496 7.69388 9.66496 6.33676V4.68948C10.373 4.90092 10.8942 5.55986 10.8942 6.33676ZM8.9274 6.33676V3.87821C8.9274 2.92921 8.15542 2.15723 7.20642 2.15723H3.27274C2.32374 2.15723 1.55176 2.92921 1.55176 3.87821V8.7953C1.55176 8.89365 1.61076 8.98705 1.70419 9.02147C1.73369 9.03622 1.76811 9.04116 1.79761 9.04116C1.86153 9.04116 1.92545 9.01662 1.97462 8.96745L2.86463 8.05774H7.20642C8.15542 8.05774 8.9274 7.28576 8.9274 6.33676Z",
    fill: "#234240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.bde07046bfb86fcab707ef37897e397b.svg";
export { ForwardRef as ReactComponent };